import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import actions from "@/actions";
import { Button, FileUpload } from "@/components";
import { getLightsToDownload } from "@/selectors";

import Row from "./Row";
import TabContent from "./TabContent";

const StyledImportFileButton = styled(Button)`
    && {
        margin-left: 16px;
    }
`;

/**
 * Tab for importing and exporting light configurations via JSON files.
 *
 * @returns The rendered bulk import tab.
 */
const BulkImport = () => {
    const dispatch = useDispatch();
    const fileUploadRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState();
    const lights = useSelector(getLightsToDownload);
    const jsonData = `text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(lights))}`;
    return (
        <TabContent>
            <Row>
                {"You can upload a JSON file to populate the map. " +
                    "Any lights that no longer exist on the backend will be created as new. " +
                    "We recommend downloading the JSON file before making any changes just in case."}
            </Row>
            <Row>
                <a href={`data:${jsonData}`} download="lights.json">
                    <Button>{"Download JSON File"}</Button>
                </a>
            </Row>
            <Row>
                <FileUpload
                    ref={fileUploadRef}
                    onSelectFile={(file) => setSelectedFile(file)}
                />
                <StyledImportFileButton
                    disabled={!selectedFile}
                    onClick={() => {
                        dispatch(
                            actions.map.advancedOperations.uploadJsonFile(
                                selectedFile,
                            ),
                        );
                        setTimeout(() => fileUploadRef.current.clean(), 100);
                    }}
                >
                    {"Import File"}
                </StyledImportFileButton>
            </Row>
        </TabContent>
    );
};

export default BulkImport;
